import React from "react";
import MovieBookingPage from "./MovieBookingPage";
import { Navigate, useNavigate } from "react-router-dom";
import reactlogo from "./logo - Copy.png"


function Home() {
    const Navigate = useNavigate();

    const handlebookclick = () => {
        Navigate('./MovieBookingPage');
    };

    return (
        <div>
            <img class="h-20 w-20 ml-40 mt-10" src={reactlogo} alt="React Image" />

        <div class="font-bold text-6xl flex flex-wrap text-center">Welcome To <br/> 
            PIXEL BOOKING</div>
         <button  class="font-bold p4 w-40 bg-white rounded ml-20 my-10  " 
         onClick={handlebookclick}
         >START BOOKING</button>
         </div>
    );
}

export default Home;